<template>
    <div class="mainTable">
        <a-table
                :rowKey="rowKey"
                :columns="columns"
                :dataSource="dataList"
                :pagination="{
        pageSize: pageSize,
        current: currentPage,
        total: total,
        size: 'small',
        showSizeChanger: false,
        showTotal: (total) => `共 ${total} 条`,
      }"
                :loading="loading"
                @change="onChange"
                selection
                :row-selection="selection ? { selectedRowKeys: selectedRowKeys, onChange: onSelectChange } : null"
                :scroll="{ x: scrollX, y: scrollY }"
        >
            <slot></slot>
            <!-- <template #title>
              <slot name="title"></slot>
            </template> -->

            <template #bodyCell="{ text, record, index, column }">
                <slot name="bodyCell" :text="text" :record="record" :index="index" :column="column"></slot>
            </template>
            <template #headerCell="{ title, column }">
                <slot name="headerCell" :title="title" :column="column"></slot>
            </template>
        </a-table>
    </div>
</template>
<script>
import { useDepartmentFilterStore } from '@/store';

export default {
    name: 'main-table',
    props: {
        columns: {
            type: Array,
            default: () => [],
        },
        rowKey: {
            type: String,
            default: 'id',
        },
        apiObj: {type: Function, default: null},
        params: {type: Object, default: () => ({})},
        selection: {type: Boolean, default: false},
        selectChange: {type: Function, default: null},
        scrollX: {type: Number, default: 0},
        scrollY: {type: Number, default: null},
        selectedRowKeys: {type: Array, default: () => []},
    },
    data() {
        return {
            dataList: [],
            selectedRows: [],
            loading: false,
            currentPage: 1,
            pageSize: 10,
            total: 0,
            selectList: [],
        };
    },
    mounted() {
        this.getList();
        // 全局订阅部门数据筛选 store，filterTick 变化时自动 refresh
        const store = useDepartmentFilterStore();
        this._lastFilterTick = store.filterTick;
        this._unsubFilter = store.$subscribe((_mutation, state) => {
            if (state.filterTick !== this._lastFilterTick) {
                this._lastFilterTick = state.filterTick;
                this.getList();
            }
        });
    },
    beforeUnmount() {
        this._unsubFilter?.();
    },
    methods: {
        getdata() {
            this.currentPage = 1;
            this.getList();
        },
        // 保留当前页码与搜索参数重新拉数据（不重置分页）
        refresh() {
            this.getList();
        },
        async getList() {
            this.loading = true;
            let reqData = {
                pageNo: this.currentPage,
                pageSize: this.pageSize,
                ...this.params,
            };
            const res = await this.apiObj(reqData);
            if (res.code === 1) {
                this.loading = false;
                this.dataList = res.list;
                this.total = res.pageTurn.rowCount;
            }
        },
        onChange(pagination, filter, sorter) {
            const {current} = pagination;
            this.currentPage = current;
            this.$emit('sorterChange', sorter);
            this.getList();
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectChange(selectedRowKeys, selectedRows);
        },
    },
};
</script>
<style lang="less" scoped>
.mainTable {
  margin-top: 20px;
  width: 100%;
}
</style>
